//
// DisplayRuleInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "./DisplayRuleType";
import "@sas-dvr/ltjs-commons/styles/AttributeBundle";
import "../../models/conditions/ConditionScope";
import "@sas-dvr/ltjs-gtl/models/Graph";
import "./IndicatorDisplayType";
import "@sas-dvr/ltjs-commons/resources/images/Image";
import "../../controllers/dataDefinition/DataItemInfo";

var DisplayRuleInfo = createModule("BIRD::DisplayRuleInfo", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getLevel: [7],
        getExpression: [7],
        getName: [7],
        getType: [4],
        getScopeDescription: [7],
        getGaugeGraph: [1],
        getGroup: [7],
        getDataItemInfo: [1],
        getStyleAttributes: [1],
        getIndicatorDisplayType: [4],
        getImage: [1],
        getScope: [4],
    },
    ,
    ,
]);
export default DisplayRuleInfo;
